import { endpoints } from 'core/consts/endpoints';
import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { axiosInstance } from '@fides/fides-react-components';

export const signOrders = (uuids: string[], securityCode: string): Promise<AxiosResponse> =>
  axiosInstance.post(`${endpoints.orders}/sign`, { uuids, securityCode }, { baseURL: endpoints.EFTApiUrl });

export const getOrderStatus = (uniqueId: string): Promise<AxiosResponse> =>
  // Keep polling from extending sessions; this flag is consumed by the shared axios interceptor.
  axiosInstance.put(`${endpoints.orders}/${uniqueId}/status`, {}, {
    baseURL: endpoints.EFTApiUrl,
    skipTokenRefresh: true,
  } as AxiosRequestConfig);

export const checkOrderStatus = async (uniqueId: string) => {
  const response = await getOrderStatus(uniqueId);
  if (response.status !== 200) {
    throw new Error('Failed to fetch order status');
  }
  return response.data;
};
